import { render, staticRenderFns } from "./LicenseItemProduct.vue?vue&type=template&id=a42ab9da&scoped=true&"
import script from "./LicenseItemProduct.vue?vue&type=script&lang=js&"
export * from "./LicenseItemProduct.vue?vue&type=script&lang=js&"
import style0 from "./LicenseItemProduct.vue?vue&type=style&index=0&id=a42ab9da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a42ab9da",
  null
  
)

export default component.exports